module.exports = __webpack_public_path__ + "media/components/global/search-explore-nav/img/photos/term-bg-7-408846f33de9e94bd76cfea976ff1d51.jpg";